<template>
  <LcFormOriginal
    ref="form"
    v-bind="{ ...sanitizedProps, ...$attrs }"
    :data-containerid="containerId"
  >
    <template v-for="(_, name) in slots" #[name]="slotData">
      <slot :name="name" v-bind="normalizedSlotData(slotData)" />
    </template>
  </LcFormOriginal>
</template>

<script generic="T extends Record<string, unknown>" lang="ts" setup>
import type { ComponentExposed } from 'vue-component-type-helpers'

import {
  LcForm as LcFormOriginal,
  type LcFormProps,
  type LcFormSlots,
} from '@lottocom/frontend-components'

import type { TrackingFormProps } from '../../app/types/tracking'

import { LcFormContext } from '../../app/types/trackingComponents'

const props = defineProps<LcFormProps<T> & TrackingFormProps>()
const slots = defineSlots<LcFormSlots<T>>()

const { pushFormAutoSubmitEvent } = useTracking()
const { log } = useDatadog()

const originalForm = useTemplateRef<ComponentExposed<typeof LcFormOriginal<T>>>('form')

const containerId = computed(() => R_toSnakeCase(props.tracking.containerId))
provide(LcFormContext, { containerId })

const sanitizedProps = computed(() => removeTrackingProps(props))

const trackAutoSubmit = () => {
  try {
    const activeElement = document.activeElement

    pushFormAutoSubmitEvent({
      finput_data_clickname:
        activeElement && activeElement instanceof HTMLElement
          ? getClickName(activeElement)
          : undefined,
      finput_data_container: containerId.value,
    })
  } catch (error) {
    log('warn', {
      component: 'LcForm.vue',
      error,
      message: 'pushFormAutoSubmitEvent failed',
    })
  }
}

defineExpose({ internal: originalForm, trackAutoSubmit })
</script>
